import { render, staticRenderFns } from "./MailGroups.vue?vue&type=template&id=dbfde89a&"
import script from "./MailGroups.vue?vue&type=script&lang=js&"
export * from "./MailGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports